import { Injectable } from '@angular/core';
import { WebApiClient } from '../../web-api-client.service';
import { WebApiService } from '../../web-api.service';
import { CustomResult } from 'src/app/shared/models/custom-result';

@Injectable({providedIn:'root'})
export class ClinicSessionApi {
  apiService: WebApiService;

  constructor(private apiClient: WebApiClient) {
    this.apiService = this.apiClient.createHisService('system/clinicSession');
  }

  async Get(id:number): Promise<ClinicSession>{
    var ret = await this.apiService.get('Get/'+id).toPromise<ClinicSession>();
    return ret;
  }

  async GetAll(clinicid:number): Promise<ClinicSession[]>{
    var ret = await  this.apiService.get(`GetAll`,{ clinicId:clinicid }).toPromise<ClinicSession[]>();
    return ret;
  }

  async SaveAll(clinicSessions:ClinicSession[]):Promise <CustomResult>{
    var ret = await  this.apiService.post(`SaveAll`,clinicSessions).toPromise();
    return ret;
  }

}



/**登入情境設定 */
export class ClinicSession {
  /** */
  Id: number;
  /**對應Clinics.Id */
  ClinicId: number;
  /**情境/狀態 名稱 */
  Name: string;
  /**衛星藥局IP */
  SatellitePhamacyIP: string;
  /**北極星主機 URL */
  PolarisHostUrl?: string;
  /**情境/狀態 類型 */
  Type?: number;
  /**特治預設 */
  DefaultSPTX: string;
  /**預設註記 */
  DefaultSpecAreaSV: string;
  /**預設支援地區代碼 */
  DefaultSupArea: string;
  /**矯正機構代碼預設 */
  JailAddressCode: string;
  /**額外內容 */
  Addition: string;
  /**是否啟用 預設 1:是 */
  IsEnabled: boolean;
  /**是否活著 預設 1:是 */
  IsAlive: boolean;

}

